export default __webpack_public_path__ + "static/media/chat3.dbeab58d.svg";